import styled from 'styled-components';
import { transparentColors } from '../../../variables/colors.js';

var Overlay = styled.div.withConfig({
  displayName: "overlay__Overlay",
  componentId: "sc-1qrf1ua-0"
})(["background:", ";height:100%;left:0;-webkit-overflow-scrolling:touch;overflow-y:auto;position:fixed;top:0;width:100%;z-index:10000;transition:opacity 0.2s ease-in-out;opacity:0;visibility:'hidden';overscroll-behavior:contain;"], transparentColors.semiTransparentblack);

export { Overlay };
//# sourceMappingURL=overlay.js.map
